export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProjectStatusSwitcher.vue?vue&type=template&id=683add4e&"


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/ProjectStatusSwitcher.vue?vue&type=template&id=683add4e&
// module id = 217
// module chunks = 0